// Fases da Revisão de Crédito (coluna `version`): Fase 1 = nulo ou 1 (cronograma); Fase 2 = 2.
// Na Fase 2 não há contraproposta: o pedido da recuperanda é uma revisão comum, com contraditório.
export function objectionPhase(event) {
  return event && Number(event.version) === 2 ? 2 : 1;
}

// Pedido da recuperanda: tipo 4 sem procurador (o procurador também grava tipo 4 em alguns casos).
export function isDebtorRequest(event) {
  return !!event && Number(event.type) === 4 && !event.lawyer_id;
}

// Pedido da recuperanda na Fase 2 (exibido como revisão, não como "contraproposta ao QGC").
export function isPhase2DebtorRequest(event) {
  return isDebtorRequest(event) && objectionPhase(event) === 2;
}

// Contraproposta da Fase 1 (data gravada e diferente do valor vazio do MySQL).
export function hasLegacyProposal(event) {
  return !!event && objectionPhase(event) === 1 && !!event.proposal_at && event.proposal_at !== '0000-00-00 00:00:00';
}

// Texto sem HTML (motivos e análises gravados pelo editor rico).
export function plainText(html) {
  if (!html) return '';
  // DOMParser cria um documento inerte: nenhum script ou evento do HTML é executado.
  const parsed = new DOMParser().parseFromString(String(html), 'text/html');
  return (parsed.body.textContent || '').replace(/\s+/g, ' ').trim();
}

export function formatMoney(value, currency) {
  if (value === null || value === undefined || value === '') return 'N/A';
  const code = { 1: 'BRL', 2: 'USD', 3: 'EUR' }[Number(currency)] || 'BRL';
  return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: code });
}

// Situação do pedido de revisão do credor, com explicação enquanto não há análise.
const REVIEW_STATUS = {
  0: { label: 'Aguardando análise', color: 'blue-grey', hint: 'A Administração Judicial ainda não analisou este pedido.' },
  1: { label: 'Aprovado', color: 'green darken-1' },
  2: { label: 'Rejeitado', color: 'red darken-1' },
  3: { label: 'Aprovado parcialmente', color: 'indigo' },
  4: { label: 'Documentos solicitados', color: 'orange darken-2', hint: 'A Administração Judicial solicitou documentos.' },
  5: { label: 'Documentos enviados', color: 'orange darken-2', hint: 'Documentos enviados. O pedido volta para a análise da Administração Judicial.' },
};

export function reviewStatus(item) {
  return REVIEW_STATUS[Number(item && item.status)] || { label: 'Em análise', color: 'blue-grey', hint: 'O pedido está em análise pela Administração Judicial.' };
}

export function hasAnalysis(item) {
  return !!item && Number(item.status) !== 0 && !!(item.small_reason || item.reason);
}

export function analysisSummary(item) {
  return plainText(item && (item.small_reason || item.reason));
}
